import { render, staticRenderFns } from "./MobileAlertCard.vue?vue&type=template&id=0af6493a&scoped=true&"
import script from "./MobileAlertCard.vue?vue&type=script&lang=js&"
export * from "./MobileAlertCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileAlertCard.vue?vue&type=style&index=0&id=0af6493a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af6493a",
  null
  
)

export default component.exports